// Module
var code = "<react-component name=\"EditWorkout\"></react-component>\n";
// Exports
module.exports = code;